import React, {Suspense} from 'react'
import {Redirect} from 'react-router'
import meetingSeriesRedirectorQuery, {

} from '../__generated__/MeetingSeriesRedirectorQuery.graphql'
import useQueryLoaderNow from '../hooks/useQueryLoaderNow'
import useRouter from '../hooks/useRouter'
import MeetingSeriesRedirector from './MeetingSeriesRedirector'

const MeetingRoot = () => {
  const {match} = useRouter()
  const {params} = match
  const {meetingId} = params
  const queryRef = useQueryLoaderNow(meetingSeriesRedirectorQuery, {
    meetingId
  })
  if (!meetingId) return React.createElement(Redirect, { to: "/meetings",} )
  return (
    React.createElement(Suspense, { fallback: '',}
      , queryRef && React.createElement(MeetingSeriesRedirector, { meetingId: meetingId, queryRef: queryRef,} )
    )
  )
}

export default MeetingRoot
